/**
 * O AVISO QUE A TELA DÁ, NO LUGAR DO `alert()` DO NAVEGADOR — `T8.15`, `T8.31`.
 *
 * ── O QUE FOI CONTADO, E É O QUE ESTE ARQUIVO EXISTE PARA ZERAR ─────────────────────────────
 *
 * Contados em 26/09, depois de eu já ter promovido este ponto cedo demais: **20 `alert()` nativos** no
 * produto. Entre eles, as duas frases que o achado cita por extenso — *"E-mail inválido"* e
 * *"E-mail de verificação enviado"*.
 *
 * Ele, na letra: *"Alertas nativos quebram a identidade"*, e o achado irmão pede *"mostrar erros junto
 * ao campo"*.
 *
 * ── POR QUE UMA FAIXA, E NÃO O MODAL DO PRODUTO EM TUDO ─────────────────────────────────────
 *
 * O modal serve a **pergunta** — ele interrompe porque precisa de resposta. Um aviso não precisa de
 * resposta: ele precisa ser lido. Pôr todo aviso num modal obriga a pessoa a fechar uma caixa para
 * continuar o que já estava fazendo, e ensina a fechar sem ler.
 *
 * A faixa fica **no formulário, acima do botão**, que é onde o olho já está quando a ação falha.
 *
 * ── `role="alert"`, E ELE NÃO É ENFEITE ─────────────────────────────────────────────────────
 *
 * É o que faz um leitor de tela anunciar o texto **sem** a pessoa ter de ir procurá-lo. É a única
 * coisa boa que o `alert()` fazia — ele roubava o foco —, e é a única que precisa ser reposta.
 */
import { useState } from "react";
import "./aviso-da-tela.scss";

export type TipoDeAviso = "erro" | "sucesso";

export interface AvisoNaTela {
  texto: string;
  tipo: TipoDeAviso;
}

/**
 * O estado de um aviso, com as duas formas de o pôr na tela.
 *
 * Devolver funções nomeadas em vez do `setState` cru é de propósito: `erro(...)` e `sucesso(...)` no
 * lugar da chamada dizem qual é o caso sem ninguém ter de ler o objeto.
 */
export function useAviso() {
  const [aviso, setAviso] = useState<AvisoNaTela | null>(null);
  return {
    aviso,
    erro: (texto: string) => setAviso({ texto, tipo: "erro" }),
    sucesso: (texto: string) => setAviso({ texto, tipo: "sucesso" }),
    limpar: () => setAviso(null),
  };
}

/** A faixa. Não renderiza nada quando não há aviso — e não um espaço vazio reservado. */
export function Aviso({ aviso }: { aviso: AvisoNaTela | null }) {
  if (!aviso) return null;
  return (
    <p className={`aviso-da-tela aviso-${aviso.tipo}`} role="alert">
      {aviso.texto}
    </p>
  );
}
